"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { useMyLinkProfileQuery } from "@/modules/creator/services/creatorClient";

const MINIMUM_KEYWORD_COUNT = 3;

export function CreatorKeywordsBanner() {
  const t = useTranslations("common");
  const { data: creatorProfile } = useMyLinkProfileQuery();
  const keywordCount = new Set(
    (creatorProfile?.settings?.jobFeedPreferences?.positiveKeywords || [])
      .map((keyword) => keyword.trim().toLowerCase())
      .filter(Boolean),
  ).size;

  if (!creatorProfile || keywordCount >= MINIMUM_KEYWORD_COUNT) return null;

  return (
    <div
      className="relative z-50 w-full border-b border-red-300 bg-red-100 px-4 py-2.5 text-center text-sm font-medium text-red-600"
      role="status"
    >
      {t("keywordBannerMessage")} {" "}
      <Link
        href="/my-link?edit=settings"
        className="font-bold text-red-700 underline underline-offset-2"
      >
        {t("keywordBannerAction")}
      </Link>
    </div>
  );
}
